
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 20 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.5 4h-1V1h-1V0h2v4zm0 9.5V13h-2v-1h3v4h-3v-1h2v-.5h-1v-1h1zM.5 7h1.8L.5 9.1v.9h3V9H1.7l1.8-2.1V6h-3v1zm5-4V1h14v2h-14zm0 12h14v-2h-14v2zm14-6h-14V7h14v2z","fill":"#000","fill-opacity":".54"}})])
          )
        }
      }
    